import { render, staticRenderFns } from "./plusOrders.vue?vue&type=template&id=5019e0cc&scoped=true&"
import script from "./plusOrders.vue?vue&type=script&lang=js&"
export * from "./plusOrders.vue?vue&type=script&lang=js&"
import style0 from "./plusOrders.vue?vue&type=style&index=0&id=5019e0cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5019e0cc",
  null
  
)

export default component.exports